"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Shield, Microscope, Snowflake, FlaskConical } from "lucide-react";
import { useT } from "@/i18n";
export default function KigaliUrbanHeritageHero() {
  const t = useT();
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const features = [{
    icon: <Shield className="size-6 text-primary" />,
    title: "Premium Quality",
    desc: "High purity research peptides"
  }, {
    icon: <Microscope className="size-6 text-primary" />,
    title: "Research Use Only",
    desc: "For laboratory and research only"
  }, {
    icon: <Snowflake className="size-6 text-primary" />,
    title: "Cold Chain Stored",
    desc: "Maintained at 2-8°C"
  }, {
    icon: <FlaskConical className="size-6 text-primary" />,
    title: "Trusted Worldwide",
    desc: "Used by researchers globally"
  }];
  return <section data-section-id="234828" id="the-future-of-biohacking" className="relative min-h-[800px] lg:h-[100svh] w-full overflow-visible flex flex-col items-center justify-center bg-cover bg-center pt-20 pb-56 lg:py-0" style={{
    backgroundImage: 'url("https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672529/img/front page background.png")'
  }}>
      <div className="absolute inset-0 bg-black/40 z-10"></div>

      <div className="container relative z-20 mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="flex flex-col items-start text-left space-y-6" style={{
          transform: `translateY(${scrollY * -0.1}px)`
        }}>
            <div className="space-y-2">
              <span className="text-white/80 font-mono text-sm tracking-widest uppercase">{t("Research Peptides")}</span>
              <h1 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl text-white leading-[1.1] tracking-tight">
                {t("Premium Quality")} <br />
                <span className="text-white/90">{t("For Superior Results")}</span>
              </h1>
            </div>
            
            <div className="space-y-1 text-white/70 font-mono text-sm">
              <p>{t("Research use only")}</p>
              <p>{t("Storage: 2-8°C in refrigerator")}</p>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild variant="outline" size="lg" className="bg-transparent text-white border-white/30 hover:bg-white/10 hover:text-white rounded-md px-8 py-6 text-base font-bold uppercase tracking-wider transition-all duration-300">
                <Link to="/ShopPage">{t("View All Products")}</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="hidden lg:block"></div>
        </div>
      </div>

      {}
      <div className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-full max-w-6xl px-6 z-40">
        <div className="bg-white rounded-lg shadow-2xl p-8 md:p-10 border border-border">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center space-y-3 group">
                <div className="p-3 rounded-lg bg-primary/5 group-hover:bg-primary/10 transition-colors">
                  {feature.icon}
                </div>
                <div className="space-y-1">
                  <h3 className="font-bold text-foreground text-sm uppercase tracking-wide">{t(feature.title)}</h3>
                  <p className="text-muted-foreground text-xs leading-relaxed">{t(feature.desc)}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}